// extracted by mini-css-extract-plugin
export var root = "NDV8";
export var rootClose = "KXdu";
export var rootHeading = "zIPt";
export var rootList = "cq1J";
export var rootListItem = "C8Bd";